export default __webpack_public_path__ + "static/mountains-xs-637b30dd204222abfb00bd9d6afe7822.png";